import { Check, Pencil, X } from "lucide-react";
import React from "react";
import { Button } from "../../../../../components/ui/common/button";

/** Edits are staged locally; Save persists everything at once via the bulk
 * cultivation-field endpoint, Cancel discards the staged edits. */
interface CultivationRowActionsProps {
  editing: boolean;
  saving: boolean;
  onEdit: () => void;
  onSave: () => void;
  onCancel: () => void;
  disabled?: boolean;
}

const CultivationRowActions: React.FC<CultivationRowActionsProps> = ({
  editing,
  saving,
  onEdit,
  onSave,
  onCancel,
  disabled = false
}) =>
  editing ? (
    <div className="tw-flex tw-justify-end tw-gap-1">
      <Button
        variant="ghost"
        size="icon"
        className="tw-h-8 tw-w-8 tw-text-primary"
        onClick={onSave}
        disabled={saving || disabled}
        title="Save"
      >
        <Check className="tw-h-3.5 tw-w-3.5" />
      </Button>
      <Button
        variant="ghost"
        size="icon"
        className="tw-h-8 tw-w-8"
        onClick={onCancel}
        disabled={saving || disabled}
        title="Cancel"
      >
        <X className="tw-h-3.5 tw-w-3.5" />
      </Button>
    </div>
  ) : (
    <div className="tw-flex tw-justify-end">
      <Button
        variant="ghost"
        size="icon"
        className="tw-h-8 tw-w-8"
        onClick={onEdit}
        disabled={disabled}
        title="Edit"
      >
        <Pencil className="tw-h-3.5 tw-w-3.5" />
      </Button>
    </div>
  );

export default CultivationRowActions;
